import { PopoverGroupOptionsMixin } from 'trunks/vue/admin/components/popover_group_options.js';

export default Vue.extend({
  mixins: [PopoverGroupOptionsMixin],

  template: `
    <popover-group-options optionsFilterPlaceholder='搜索类型'
                           :initialSelectedOptionIds='initialSelectedOptionIds'
                           :formatDataFunc='formatTypes'
                           :needFilterInput='false'
                           ref='popoverGroupOptionsRef'
                           @cancelClicked='cancelFunc'
                           @submitClicked='submitFunc'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='tip gray-text'>
          <i :class='option.icon'></i>
        </div>
        <div class='content'>
          <span>{{ option.name }}</span>
        </div>
        <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
      </template>

      <div slot='filter-blankslate' class='list-group'>
        <div class="list-group-name">没有相关的搜索结果</div>
      </div>
    </popover-group-options>
  `,

  props: {
    initialSelectedOptionIds: {
      type: Array,
    },
  },

  data() {
    return {
      tagGroups: [],
    };
  },

  methods: {
    formatTypes() {
      return [{
        id: Skylark.Helpers.Utilities.uuid(),
        options: [
          { id: 'post', name: '普通通知', icon: 'slp-pack-o' },
          { id: 'form', name: '表单', icon: 'slp-list-square-o' },
          { id: 'template_post', name: '模板通知', icon: 'slp-list-info-o' },
        ],
      }];
    },
  },
});
